import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DestinationService {

  private URL = environment.api + "api/erp/destinations";
  
    constructor(private http: HttpClient) { }

    createDestination(data: any){
      return this.http.post(this.URL, data);
    }

    createDestinationWareshouse(destinationId: any, warehouseId: any){
      return this.http.post(this.URL+ `/${destinationId}/warehouses/${warehouseId}`, {});
    }

    createDestinationWareshouseWithDates(destinationId: any, warehouseId: any, data: any){
      return this.http.post(this.URL+ `/${destinationId}/warehouses/${warehouseId}/with-dates`, data);
    }

    createDestinationExpense(destinationId: any, expenseId: any){
      return this.http.post(this.URL+ `/${destinationId}/expenses/${expenseId}`, {});
    }

    getDestination(destinationId: any) {
      return this.http.get(this.URL+ `/${destinationId}`);
    }

    getDestinations() {
      return this.http.get(this.URL);
    }

    getDestinationsActive(active: boolean) {
      return this.http.get(this.URL+ `/active/${active}`);
    }

    getWarehouseDestinationsByEffectiveDate(effectiveDate: any) {
      return this.http.get(this.URL+ `/date/${effectiveDate}`);
    }

    getWarehouseDestinationsWithUserByEffectiveDate(effectiveDate: any) {
      return this.http.get(this.URL+ `/date/${effectiveDate}/with-users`);
    }

    getWarehouseDestinationsByEffectiveDateAndDestination(destinationId: any, effectiveDate: any) {
      return this.http.get(this.URL+ `/${destinationId}/date/${effectiveDate}`);
    }

    getWarehouseDestinationsWithUserByEffectiveDateAndDestination(destinationId: any, effectiveDate: any) {
      return this.http.get(this.URL+ `/${destinationId}/date/${effectiveDate}/with-users`);
    }

    getWarehouseDestinationsByEffectiveDateAndWarehouse(warehouseId: any, effectiveDate: any) {
      return this.http.get(this.URL+ `/warehouses/${warehouseId}/date/${effectiveDate}`);
    }

    getWarehouseDestinationsWithUserByEffectiveDateAndWarehouse(warehouseId: any, effectiveDate: any) {
      return this.http.get(this.URL+ `/warehouses/${warehouseId}/date/${effectiveDate}/with-users`);
    }

    getWarehouseDestinationsWithUserByEffectiveDateAndWarehouseToday(warehouseId: any) {
      return this.http.get(this.URL+ `/warehouses/${warehouseId}/today/with-users`);
    }

    getDestinationExpense(expenseId: any){
      return this.http.get(this.URL+ `/expenses/${expenseId}`);
    }

    updateDestination(destinationId: any, data: any) {
      return this.http.put(this.URL+ `/${destinationId}`, data);
    }

    updateActiveDestination(destinationId: any) {
      return this.http.put(this.URL+ `/${destinationId}/active`, {});
    }

    deleteDestination(destinationId: any) {
      return this.http.delete(this.URL+ `/${destinationId}`);
    }

    getWarehouses() {
      return this.http.get(environment.api + "api/erp/inventory/warehouse/search/existing",
        {
          params: {
            clue: ''
          }
        }
      );
    }

    assignWarehouseToExpense(expenseId: number, warehouseId: number) {
      return this.http.post(
        this.URL + `/expenseAllocation/${expenseId}/${warehouseId}`,
        {}
      );
    }

}
